<template>
  <span>
    <el-dialog
    title="新增"
    :close-on-click-modal="false"
    :visible.sync="addDetailFlag"
    :fullscreen="dialogFull"
    :before-close="handleClose"
    @close="addForm={};tableData=[];remainUserList=[];"
    append-to-body
    width="65%">
    
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        {{"新增"}}
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                                
                        </div>
                        <el-divider></el-divider>
                </template>
        <!-- <div>新增详情：{{query.projectId}}</div> -->
        <avue-form ref="addForm" 
        style="height: 50vh;overflow: scroll;" 
        v-if="addDetailFlag" v-model="addForm" :option="option" @reset-change="emptytChange" @submit="submit">
       
   <template slot-scope="{}" slot="checkItemLabel">
       <div>{{' '}}</div>
   </template>
   <template slot-scope="scope" slot="userIdList">
       <!-- :limit="1" -->
              <UserEditBox2
                v-model="addForm.userIdList"
                :remainUserListInside.sync="remainUserList"
                :projectId="addForm.projectId"
                :placeholder.sync="placeholder"
                :disabled="pageMode == 0"
              />
   </template>
            <template slot-scope="{}" slot="checkItem">
                <div>
                    <el-table border :data="tableData" height="300">
                        <el-table-column
                        label="#"
                        align="center"
                        header-align="center"
                        type="index">
                        </el-table-column>
                        <el-table-column
                        prop="content"
                        label="标准内容"
                        width="280">
                        </el-table-column>
                        <el-table-column
                        prop="demand"
                        label="考核要求"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="score"
                        label="分值">
                        </el-table-column>
                        <el-table-column
                        prop="baseScore"
                        label="基准分值">
                        </el-table-column>
                    </el-table>
                </div>
            </template>
        </avue-form>

                <template slot="footer">
                        <el-divider></el-divider>
                        <div>
                              <el-button icon="el-icon-circle-plus-outline" :disabled="submitDisabledFlag" @click="submit" size="small" type="primary">{{ '保 存' }}</el-button>  
                              <el-button icon="el-icon-circle-close" style="margin-right:10px" size="small" @click="addForm={};tableData=[];handleClose();">取 消</el-button>
                        </div>
                </template>
     
  <!-- <template slot="menuForm">
    <el-button  icon="el-icon-delete" @click="addForm={};tableData=[];remainUserList=[];handleClose();">取 消</el-button>
  </template> -->
    </el-dialog>
        <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addDetailFlag=true;initPage()"
        >
          新增
        </el-button>
  </span>
</template>

<script>
import { add, getDetail, getList, remove, update, getProjectDic,getStandardNameList,getStandardInfo,getStandardDetailList } from '@/api/v4ward/assess/task/assesstask';
import {getProjectList} from "@/api/crmedical/group/group";
        import { getDictionary } from '@/api/common';
import UserEditBox2 from "@/views/components/user-edit-box2";
export default {
    
  components: { UserEditBox2 },
  props: {
    query: {
      default: ()=>{}, //项目id
    },
  },

    data(){
        let disabled = false;
        return{
          placeholder:'请选择考评人员',
            dialogFull:false,
            remainUserList:[],
            pageMode:1,
            addForm:{},
            addDetailFlag:false,
            submitDisabledFlag:false,
            tableData:[],
      option: {
        //   mockBtn:true,
          submitText: '保存',
          cancelBtn:true,
        emptyBtn:false,
          submitBtn:false,
        //   printBtn:true,
        column: [
          // {
          //   label: '主键',
          //   prop: 'id',
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入主键',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          {
            // label: '项目id',
            disabled: disabled,
            label: '项目名称',
            prop: 'projectId',
            searchValue:'66666',
            type:'select',
            span:8,
            props:{
              label:'name',value:'id'
            },
            // bind:'query.projectId',
            change:(value,column)=>{
              console.log(value,column);
              this.addForm.projectId = value.value;
              if(value.value){
                this.addForm.objectType = '';
                this.addForm.standardId = '';
                this.getDicData(value.value);
              }
            },
            dicData:[],
            // bind:'query.projectId',
            // change:(value,column)=>{
            //   console.log(value,column);
            //   this.query.projectId = value.value;
            // },
            rules: [
              {
                required: true,
                message: '请输入项目名称',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            // label: "考核对象类型,取自项目字典project_assess_object_type",
            label: '考核对象',
            prop: 'objectType',
            search: true,
            span:8,
            type:'select',
            props:{
              label:'dictValue',value:'dictKey'
            },
            dicData:[],
            change:(value,column)=>{
              console.log(value,column);
              if(value.value){
                this.addForm.objectType = value.value;
                this.addForm.standardId = '';
                this.getStandardNameData(value.value,this.addForm.projectId);
              }
            },
            rules: [
              {
                required: true,
                // message: '请输入考核对象类型,取自项目字典project_assess_object_type',
                message: '请输入考核对象类型',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            // label: '标准id',
            label: '标准名称',
            prop: 'standardId',
            span:8,
            type:'select',
            props:{
              label:'name',value:'id'
            },
            dicData:[],
            change:(value,column)=>{
              console.log(value,column);
              this.addForm.standardId = value.value;
              if(value.value){
                this.getStandardInfoData(value.value);
                this.getStandardDetailListData(value.value);
              }
            },
            rules: [
              {
                required: true,
                // message: '请输入标准id',
                message: '请输入标准名称',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            label: '任务名称',
            prop: 'name',
            search: true,
            maxlength:'50',
            showWordLimit:true,
            type:'input',
            span:24,
            rules: [
              {
                required: true,
                message: '请输入任务名称',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: true,
            label: '总分',
            prop: 'totalScore',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     message: '请输入总分',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: true,
            label: '基准分',
            prop: 'baseScore',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     message: '请输入基准分',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: true,
            // label: '关联合同id',
            label: '合同名称',
            prop: 'contractName',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     // message: '请输入关联合同id',
            //     message: '请输入合同名称',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: true,
            // label: '关联合同id',
            label: '合同编号',
            prop: 'contractCode',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     // message: '请输入关联合同id',
            //     message: '请输入合同编号',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: true,
            // label: '关联合同id',
            display:false,
            label: '合同Id',
            prop: 'contractId',
            span:8,
            // rules: [
            //   {
            //     required: true,
            //     // message: '请输入关联合同id',
            //     message: '请输入合同Id',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            disabled: disabled,
            // label: '通知方式（多选）：1-系统消息；2-短信；3-微信；',
            label: '通知方式',
            prop: 'systemNotifyWays_',
            span:8,
            type:'select',
            props:{
              label:'dictValue',value:'dictKey'
            },
            multiple:true,
            dicData:[],
            change:(value,column)=>{
              console.log(value,column);
              if(value.value){
                this.addForm.systemNotifyWays = value.value.join(',');
              }
            //   this.getStandardInfoData(value.value);
            },
            rules: [
              {
                required: true,
                // message: '请输入通知方式（多选）：1-系统消息；2-短信；3-微信；',
                message: '请输入通知方式',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            label: '任务时间',
            prop: 'taskTime',
            type: 'datetimerange',
            rangeSeparator:'至',
            startPlaceholder:'开始时间',
            endPlaceholder:'结束时间',
            span:16,
            valueFormat:'yyyy-MM-dd HH:mm:ss',
            defaultTime:['00:00:00','23:59:59'],
            change:(value,column)=>{
              console.log(value,column);
              if((value.value+'')&&((value.value+'')!=='null')){
                this.addForm.startTime = value.value[0];
                this.addForm.endTime = value.value[1];
              }
            //   this.getStandardInfoData(value.value);
            },
            rules: [
              {
                required: true,
                message: '请输入任务时间',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            label: '考评人员',
            prop: 'userIdList',
              formslot:true,
            // type: 'datetime',
            span:16,
            rules: [
              {
                required: true,
                message: '请输入考评人员',
                trigger: 'change',
              },
            ],
          },
          {
            disabled: disabled,
            label: '备注',
            prop: 'description',
            type: 'textarea',
            maxlength:'200',
            span:24,
            showWordLimit:true,
            placeholder:"请输入备注",
            // rules: [
            //   {
            //     required: true,
            //     message: '请输入备注',
            //     trigger: 'change',
            //   },
            // ],
          },
          {
            label: '考核项目',
            prop: 'checkItem',
            // type: 'datetime',
              formslot:true,
            //   labelslot:true,
            labelPosition:'top',
            span:24,
            // rules: [
            //   {
            //     required: true,
            //     message: '请输入考核项目',
            //     trigger: 'change',
            //   },
            // ],
          },
        ],
      },
        }
    },

methods:{
  
                        
                // 弹窗关闭前
                handleClose(done){
                        let self = this;
                        this.$confirm('确认关闭?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                        })
                        .then(()=> {
                                
                                        self.addDetailFlag = false;
                                if(done){
                                        // this.selectTimeFlag = false;

                                }else{
                                        // this.selectTimeFlag = false;
                                }
                                        // done();
                        })
                        .catch(()=> {
                                
                        });
                },
    submit(done){
      if(this.submitDisabledFlag){
        return;
      }
      this.submitDisabledFlag = true;
      this.$refs.addForm.validate((valid)=>{
        if(valid){
          add(this.addForm).then((res)=>{
              console.log(res.data);
              this.$message.success('操作成功！');
              this.$emit('refreshAction');
              this.addDetailFlag = false;
              this.submitDisabledFlag = false;
              this.addForm = {};this.tableData=[];this.remainUserList=[];
              if(done){
                  done();
              }
          }).catch((err)=>{
              this.submitDisabledFlag = false;
            // this.$message.error(err.msg);
          });
        }else{
          this.submitDisabledFlag = false;
        }
      })
    },
    getStandardDetailListData(standardId){
        getStandardDetailList({standardId:standardId}).then((res)=>{
            this.tableData = res.data;
            this.addForm.checkItem = res.data;
        });
    },
    getStandardInfoData(standardId){
        getStandardInfo({id:standardId}).then((res)=>{
            console.log(res);
            this.addForm.contractName = res.data.contractName;
            this.addForm.contractCode = res.data.contractCode;
            this.addForm.contractId = res.data.contractId;
            this.addForm.baseScore = res.data.baseScore;
            this.addForm.totalScore = res.data.totalScore;
        })
    },
    getStandardNameData(objectType,projectId){
        getStandardNameList({objectType:objectType,projectId:projectId}).then((res)=>{
            this.setSearchFormDic('standardId',res.data);
        });
    },
    initPage(){
        console.log("this.$ref.addForm====>",this.$refs.addForm);
        // this.addForm.projectId = this.query.projectId;
        getProjectList().then((res)=>{
        console.log(res);
        this.projectList = res.data;
        // this.addForm.projectId = res.data[0].id;
        this.addForm.projectId = this.query.projectId;
            // this.setSearchFormValue('crud','projectId',res.data[0].id);
            this.setSearchFormDic('projectId',res.data);
            this.getDicData(this.addForm.projectId);
        });
    },
    getDicData(projectId){
      getProjectDic({projectId:projectId,code:'project_examine_service_type'}).then((res)=>{
        this.setSearchFormDic('objectType',res.data);
      });
    //   system_notify_way
    getDictionary('system_notify_way').then((res)=>{
        this.setSearchFormDic('systemNotifyWays_',res.data);
      });
    //   getDictionary('assess_task_work_status').then((res)=>{
    //     this.setSearchFormDic('workStatus',res.data);
    //   });
    },
    setSearchFormDic(prop,list){
      const column = this.findObject(this.option.column, prop);
      if(list.length==0){
        list = [{}];
      }
      column.dicData = list;
    },
    setSearchFormValue(ref,prop,value){
        setTimeout(()=>{
          this.$refs[ref].$refs.headerSearch.$refs.form.form[prop] = value;
        });
    },
},


}
</script>

<style lang="scss" scoped>
::v-deep .avue-form__menu--center {
    text-align: right;
}
</style>